<template>
  <div class="flowLog-container">
    <div v-for="item in logData" class="flowLog-item">
      <div class="fl w-190 ovf-hd" :title="item.content">{{item.content}}</div>
      <div class="fl m-l-20">{{item.create_time | toTime}}</div>
    </div>
  </div>
</template>
<style scoped>
.w-190 {
  width: 190px;
  text-overflow:ellipsis;
  white-space: nowrap
}
.flowLog-container {
  position: absolute;
  top: 20px;
  left: -100px;
  padding: 5px;
  background: #fff;
  border: 1px solid #e5e5e5;
  z-index: 999;
  font-size: 12px;
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  -ms-border-radius: 3px;
  -o-border-radius: 3px;
}
.flowLog-item {
  height: 30px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid #e5e5e5;
  overflow: hidden;
}
.flowLog-item:last-child {
  padding-bottom: 0px;
  border-bottom: 0px;
}
</style>
<script>
  import http from '../../../assets/js/http'

  export default {
    name: 'flowLog',
    props: {
      caseId: {
        type: Number,
        default() {
          return 0
        }
      }
    },
    data() {
      return {
        logData: []
      }
    },
    methods: {
      getFlowLog() {
        this.apiGet(`bpm/cases/${this.caseId}/logs`).then((res) => {
          if (res.code == 200) {
            this.logData = res.data
          }
        })
      }
    },
    created() {
      this.getFlowLog()
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// log.vue?12a9d051